import {useRef} from "react";

interface PropsType {
    addFileCallback: (files: File[]) => any,
    customRenderer?: (onClick: any, disabled: any) => any,
    title?: string,
    accept?: string,
    multiple?: boolean,
    disabled?: boolean
}

export default function FileUploadNoText({
                                             addFileCallback,
                                             customRenderer,
                                             title = "파일 업로드",
                                             accept,
                                             multiple,
                                             disabled
                                         }: PropsType) {
    const ref = useRef<any>(null);

    const handleButtonClick = () => {
        ref.current?.click();
    };

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const {files: fileList} = e.target;

        if (fileList) {
            const files = Array.from(fileList);

            addFileCallback(files);
            e.target.value = "";
        }
    };

    return <>
        {/*<label htmlFor="file-upload">*/}
        {customRenderer
            ? customRenderer(handleButtonClick, disabled)
            : <button
                className="btn btn-outline-secondary"
                onClick={handleButtonClick}
                disabled={disabled}>
                {title}
            </button>}
        {/*</label>*/}
        <input
            type={"file"}
            id={"file-upload"}
            className={"d-none"}
            ref={ref}
            onChange={handleChange}
            accept={accept}
            multiple={multiple}
            disabled={disabled}
        />
    </>
}